import http from "V2.0/services/httpService";

const endPoint: string = "/knowledgeBase";

function getKnowledgebases({ projectId }) {
  return http.get(`${endPoint}/whitelabelKbList/${projectId}`);
}

function createKnowledgebase({
  projectId,
  payload,
}: {
  projectId: string;
  payload: { label: string };
}) {
  return http.post(
    `${endPoint}/whitelabelCreateKnowledgeBase/${projectId}`,
    payload
  );
}

function deleteKnowledgebase({
  projectId,
  _id,
  isForceDelete,
}: {
  projectId: string;
  _id: string;
  isForceDelete: boolean;
}) {
  return http.delete(
    `${endPoint}/whitelabelDeleteKnowlegeBase/${projectId}/${_id}${
      isForceDelete ? "?force=true" : ""
    }`
  );
}

function getKnowledgebase({ projectId, knowledgebaseId }) {
  return http.get(
    `${endPoint}/whitelabelGetKnowledgebase/${projectId}/${knowledgebaseId}`
  );
}

function addParagraph({ projectId, knowledgebaseId, payload }) {
  return http.post(
    `${endPoint}/whitelabelAddParagraph/${projectId}/${knowledgebaseId}`,
    payload
  );
}

function updateParagraph({ projectId, knowledgebaseId, payload }) {
  return http.put(
    `${endPoint}/whitelabelUpdateParagraph/${projectId}/${knowledgebaseId}`,
    payload
  );
}

function deleteParagraph({ projectId, knowledgebaseId, key }) {
  return http.delete(
    `${endPoint}/whitelabelDeleteParagraph/${projectId}/${knowledgebaseId}/${key}`
  );
}

function addURLToKB(workspaceId: string, kbId: string, obj: any) {
  return http.post(`${endPoint}/whitelabelUrlist/${workspaceId}/${kbId}`, obj);
}

function addWeblink({ workspaceId, kbId, payload }) {
  return http.post(
    `${endPoint}/whitelabelAddUrlData/${workspaceId}/${kbId}`,
    payload
  );
}

function deleteCorpusByEtag(workspaceId: string, kbId: string, etag: string) {
  return http.delete(
    `${endPoint}/whitelabelDeleteCorpus/${workspaceId}/${kbId}/${etag}`
  );
}

function docsUpload(workspaceId: string, kbId: string, formData) {
  return http.post(
    `${endPoint}/whitelabelUpload/${workspaceId}/${kbId}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
}

function addGSheet(
  kbId: string,
  workspaceId: string,
  payload: { url: string }
) {
  // const params = new URLSearchParams({
  //   url: url,
  // })

  return http.post(
    `${endPoint}/whitelabelAddSheet/${workspaceId}/${kbId}`,
    payload
  );
}

function syncGSheet(
  kbId: string,
  workspaceId: string,
  payload: { eTag: string }
) {
  return http.post(
    `${endPoint}/whitelabelSyncGSheet/${workspaceId}/${kbId}`,
    payload
  );
}

function deleteCorpus(kbId: string, workspaceId: string, eTag: string) {
  return http.delete(
    `${endPoint}/whitelabelDeleteCorpus/${workspaceId}/${kbId}/${eTag}`
  );
}

function getDocumentDownloadLink(workspaceId, kbId, etag) {
  return http.post(
    `${endPoint}/whitelabelGetDocumentDownloadLink/${workspaceId}/${kbId}/${etag}`
  );
}

function getKBBoundedAssistants({ workspaceId, kbId }) {
  return http.get(`${endPoint}/whitelabelGetAssistants/${workspaceId}/${kbId}`);
}

function updateGSheetIntervalSettings({ workspaceId, kbId, eTag, payload }) {
  return http.put(
    `${endPoint}/whitelabelUpdateSheetIntervalSettings/${workspaceId}/${kbId}/${eTag}`,
    payload
  );
}

export {
  getKnowledgebases,
  getKnowledgebase,
  createKnowledgebase,
  deleteKnowledgebase,
  addParagraph,
  updateParagraph,
  deleteParagraph,
  addURLToKB,
  deleteCorpusByEtag,
  docsUpload,
  syncGSheet,
  addGSheet,
  deleteCorpus,
  getDocumentDownloadLink,
  getKBBoundedAssistants,
  addWeblink,
  updateGSheetIntervalSettings,
};
